import type { ReactNode } from "react";
import React from "react";

import BrandProvider from "../brand";
import type { Brands } from "../brand/types";
import { CurrencyFormatProvider } from "../currency/CurrencyFormatProvider";
import { CurrencyLocaleProvider } from "../currency/CurrencyLocaleProvider";
import { DateLocaleProvider } from "../date/DateLocaleProvider";
import LocaleProvider from "../locale/LocaleProvider";
import SiteProvider from "../sites/SiteProvider";
import type { CurrencyFormat } from "../types";

interface WebSiteConfigProviderProps {
  site: unknown;
  brand: Brands;
  locale: string;
  dateLocale: unknown;
  currencyLocale: unknown;
  currencyFormat?: CurrencyFormat;
  children: ReactNode;
}

export const WebSiteConfigProvider = ({
  site,
  brand,
  locale,
  dateLocale,
  currencyLocale,
  currencyFormat,
  children,
}: WebSiteConfigProviderProps) => (
  <SiteProvider site={site}>
    <BrandProvider brand={brand}>
      <LocaleProvider locale={locale}>
        <DateLocaleProvider locale={dateLocale}>
          <CurrencyLocaleProvider locale={currencyLocale}>
            <CurrencyFormatProvider currencyFormat={currencyFormat}>
              {children}
            </CurrencyFormatProvider>
          </CurrencyLocaleProvider>
        </DateLocaleProvider>
      </LocaleProvider>
    </BrandProvider>
  </SiteProvider>
);
